"use client";

import { useEffect, useRef } from "react";
import {
  configureWechatShareCard,
  isWechatInAppBrowser,
  type WechatShareCardConfig,
} from "@/lib/wechatShare";

const MAX_ATTEMPTS = 3;
const RETRY_MS = 1200;

/** 在微信内置浏览器打开页面时，配置转发链接卡片（标题、描述、缩略图） */
export function useWechatShareCard(config: WechatShareCardConfig, enabled = true): void {
  const attemptRef = useRef(0);
  const { title, description, link, imageUrl } = config;

  useEffect(() => {
    if (!enabled || typeof window === "undefined" || !isWechatInAppBrowser()) return;

    let cancelled = false;
    let retryTimer: ReturnType<typeof setTimeout> | undefined;

    const run = () => {
      if (cancelled) return;
      attemptRef.current += 1;

      void configureWechatShareCard({ title, description, link, imageUrl })
        .catch(() => {
          if (cancelled || attemptRef.current >= MAX_ATTEMPTS) return;
          retryTimer = setTimeout(run, RETRY_MS);
        });
    };

    run();

    return () => {
      cancelled = true;
      if (retryTimer) clearTimeout(retryTimer);
    };
  }, [enabled, title, description, link, imageUrl]);
}
